import React from 'react';

const CardUI = ({ children, style }) => {
    const defaultStyle = { padding: '10px', paddingBlockEnd: '1px' };

    const combinedStyle = {
        ...defaultStyle,
        ...style,
    };

    return (
        <div className="card" style={{ borderRadius: '8px' }}>
            <div className="card-content" style={combinedStyle}>
                {children}
            </div>
        </div>
    );
};

export default CardUI;